var _rect, _text, _path, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTravaioIconV1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#040d1a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 38,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontWeight: 700,
    fontSize: 42,
    fill: "#ffffff",
    dominantBaseline: "central"
  }, "T")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 48 C 16 38, 28 38, 36 44 S 52 52, 60 44",
    fill: "none",
    stroke: "#00c8f8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 54,
    x2: 20,
    y2: 54,
    stroke: "#00c8f8",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    opacity: 0.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 59,
    x2: 15,
    y2: 59,
    stroke: "#00c8f8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravaioIconV1);
export default __webpack_public_path__ + "static/media/travaio_icon_v1.1525efb5c70c2bccddc16aaded88722b.svg";
export { ForwardRef as ReactComponent };